import React from 'react';
import InputLabel from '../../widgets/input-label';
import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Defaults from '../../../../shared/constants/defaults';
import FormSettings from '../../../../shared/constants/form-settings';
import TinyMCE from 'react-tinymce';
import FormActions from '../../../../shared/actions/form';
import objectAssign from 'object-assign';
import InputHint from '../../widgets/input-hint';
import InputPlaceholder from '../../widgets/input-placeholder';
import ElementConstants from '../../../../shared/constants/elements';

export default class ContactElement extends React.Component {

    constructor (props){
        super(props);
        this.props.data.initialized = false;
    }

	componentDidUpdate() {
		if ( !this.props.data.initialized ) {
			const {
				fieldsetIndex,
				rowIndex,
				index
			} = this.props;
            FormActions.initializeContact(fieldsetIndex, rowIndex,index);
			this.props.data.initialized = true;
			/**
			 * Removing empty div
			 */
			FormActions.removeElement(this.props.fieldsetIndex, this.props.rowIndex, this.props.index);
		}
	}

    render(){
        return(
			/**
			 * This div will be eliminated on componentDidUpdate just is a required element to be
			 * a valid react component
			 */
            <div> </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/contact.js